import { render } from "./OnTimeDeliveryChart.vue?vue&type=template&id=30c04746&ts=true"
import script from "./OnTimeDeliveryChart.vue?vue&type=script&lang=ts"
export * from "./OnTimeDeliveryChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__